export default "__VITE_ASSET__bbcbeddb__"